import React from 'react';

function AccountCreated() {
  return (
    <section className="auth-page contain contain-smaller align-middle">
      <h1>Account Created</h1>

      <div>
        <p>
          Thanks for signing up! This MVP uses <strong>Supabase</strong> to send confirmation emails — check your spam or promotions folder just in case. 
        </p>
      </div>

      <div className="legal-links">
        <p className="text-center">
          By continuing, you agree to the <br />
          <a href="/legal.html#terms-of-use" className="primary-text">Terms of Use</a> &{' '}
          <a href="/legal.html#privacy-policy" className="primary-text">Privacy Policy</a>
        </p>
      </div>
    </section>
  );
}

export default AccountCreated;